/**
 * Texte avec couleur de branding automatique pour les formulaires publics (référent + candidat)
 */
import { useReferentBrandingColors } from '@/hooks/useReferentBrandingColors';

interface BrandingSettings {
  enabled: boolean;
  logo_url?: string;
  primary_color?: string;
}

interface BrandedTextProps {
  children: React.ReactNode;
  className?: string;
  branding?: BrandingSettings | null;
  as?: 'span' | 'div' | 'p' | 'h1' | 'h2' | 'h3' | 'h4';
  variant?: 'primary' | 'success';
}

export const BrandedText = ({ 
  children, 
  className = '', 
  branding, 
  as: Component = 'span',
  variant = 'primary'
}: BrandedTextProps) => {
  const colors = useReferentBrandingColors(branding);
  
  const colorMap = {
    primary: colors.primary,
    success: colors.success
  };
  
  return (
    <Component 
      className={className}
      style={{ color: colorMap[variant] }}
    >
      {children}
    </Component>
  );
};